import { createSelector } from 'reselect'
import { getSelectedFacets } from 'selectors/searchProvider'

export const getSelectedFacetsPriceMinMax = createSelector([getSelectedFacets], (selectedFacets): {
  priceMin: number | null
  priceMax: number | null
} => {
  const geoPrices = selectedFacets?.['custom__geo_prices']?.[0]
  const printPrice = selectedFacets?.['custom__print_all_prices']?.[0]
  const [min, max] = (geoPrices || printPrice || '').split('-')
  const minValue = max && !isNaN(Number(min)) ? Number(min) : null
  const maxValue = !isNaN(Number(max)) ? Number(max) : null
  return {
    priceMin: minValue,
    priceMax: maxValue,
  }
})
